export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  

  let date = new Date(dateString);
  
  if (isNaN(date.getTime()) && typeof dateString === 'string') {
      const parts = dateString.split(/[/s,:]+/); 
      if (parts.length >= 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; 
          const year = parseInt(parts[2], 10);
          const hour = parts.length > 3 ? parseInt(parts[3], 10) : 0;
          const min = parts.length > 4 ? parseInt(parts[4], 10) : 0;
          const sec = parts.length > 5 ? parseInt(parts[5], 10) : 0;
          
          date = new Date(year, month, day, hour, min, sec);
      }
  }

  if (isNaN(date.getTime())) return "Invalid Date";

  return date.toLocaleString(); 
};